import type { Document } from '@lmc/ts-common'
import { reportsConstants } from 'locale/team'
import _ from 'lodash'
import { getNominative } from '../../../../common/utils'

export const MODAL_ID = 'documentModal'

export const getNoDocumentsMessage = (preferredPeopleNominative: string) =>
  `You haven't added any documents for this ${getNominative(
    preferredPeopleNominative,
    'resident'
  )}`

export const getSupportSummary = (carePlanNominative: string) =>
  `Add documents (${getNominative(
    carePlanNominative,
    'Care Plans'
  )}, assessment forms etc.) so they're viewable here and on the Carer App.`

export const getSupportSummarySeniors = (carePlanNominative: string) =>
  `Admins can add documents (${getNominative(
    carePlanNominative,
    'Care Plans'
  )}, assessment forms etc.) so they're viewable here and on the Carer App.`

export const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/the-care-office/finishing-your-essential-setup/how-do-i-upload-a-document-to-a-residents-profile'

export const groupDocuments = (
  documents: Document[],
  carePlanNominative: string,
  archivingEnabled = false
) => {
  type DocumentExtended = Document & {
    archived?: boolean
    carePlanName?: string
    categoryName: string
  }

  // Archived documents are pulled out of the active view entirely and shown in
  // their own section at the bottom. When archiving is disabled we leave the
  // existing grouping untouched.
  const activeDocuments = archivingEnabled
    ? documents.filter((doc) => !(doc as DocumentExtended).archived)
    : documents

  const groupedDocs: any = _(activeDocuments)
    .filter((doc) => !(doc as DocumentExtended).carePlanName)
    .map((document: DocumentExtended) => ({
      ...document,
      categoryName: document.categoryName || 'Other'
    }))
    .sortBy('categoryName')
    .groupBy('categoryName')
    .value()

  const carePlanTitle = `Attached to ${getNominative(
    carePlanNominative,
    'Care Plans'
  )}`
  const carePlanDocs = _(activeDocuments)
    .filter((doc) => !!(doc as DocumentExtended).carePlanName)
    .map((document) => ({
      ...document,
      categoryName: carePlanTitle
    }))
    .value()

  if (carePlanDocs.length) {
    groupedDocs[carePlanTitle] = carePlanDocs
  }

  if (archivingEnabled) {
    const archivedDocs = _(documents)
      .filter((doc) => !!(doc as DocumentExtended).archived)
      .sortBy('name')
      .map((document) => ({
        ...document,
        categoryName: reportsConstants.ARCHIVED_DOCUMENTS_TITLE
      }))
      .value()

    if (archivedDocs.length) {
      groupedDocs[reportsConstants.ARCHIVED_DOCUMENTS_TITLE] = archivedDocs
    }
  }

  return {
    groupedDocs,
    hasDocuments: !!Object.keys(groupedDocs).length
  }
}
